import { pushSnackbar } from 'FRONTEND/actions/app';
import { CONSULTATION_CREATION } from 'FRONTEND/actions/constants';
import { uploadEnd, uploadProgress, uploadStart } from 'FRONTEND/actions/upload';
import { postForm } from 'FRONTEND/utils/backendApi/upload';
import { UPLOAD_TOLERANCE } from 'FRONTEND/utils/constants';
import i18n from 'FRONTEND/utils/i18n';
import { PJAX_MAIN_CONTAINER_SELECTOR } from 'LEGACY/constants';

const reloadList = () => {
  const consultationsList = document.querySelectorAll('#consultations-list, #patient-history-list');
  if (consultationsList.length) {
    $.pjax.reload({ container: PJAX_MAIN_CONTAINER_SELECTOR });
  }
};

const upload = (store) => (next) => async(action) => {
  switch (action.type) {
    case CONSULTATION_CREATION: {
      const draftFormData = new FormData();
      let hasFile = false;
      for (const [key, value] of action.payload.data.entries()) {
        if (!(value instanceof File)) {
          draftFormData.append(key, value);
        } else {
          hasFile = true;
        }
      }

      const creationUrl = new URL(action.payload.submitUrl, window.location.origin);
      let toleranceTimeout;
      let wasRedirected = false;
      const getWasRedirected = () => wasRedirected;
      if (!hasFile) {
        if (action.payload.isDraft) {
          creationUrl.searchParams.append('d', 'True');
        }
        const { message, variant, links } = await postForm({
          data: action.payload.data,
          url: creationUrl.href,
        });
        const selfURl = links.find(({ rel }) => rel === 'self').href;
        $.pjax({ url: selfURl, container: PJAX_MAIN_CONTAINER_SELECTOR });

        store.dispatch(pushSnackbar({
          message,
          variant,
        }));
      } else {
        creationUrl.searchParams.append('d', 'True');
        const { id, links } = await postForm({
          data: draftFormData,
          url: creationUrl.href,
        });
        toleranceTimeout = setTimeout(() => {
          $.pjax({ url: action.payload.redirectUrl, container: PJAX_MAIN_CONTAINER_SELECTOR });
          wasRedirected = true;
        }, UPLOAD_TOLERANCE);
        store.dispatch(uploadStart({ id }));

        const selfURl = links.find(({ rel }) => rel === 'self').href;
        const updateUrl = new URL(links?.find(({ rel }) => rel === 'update').href, window.location.origin);
        if (action.payload.isDraft) {
          updateUrl.searchParams.append('d', 'True');
        }
        try {
          const { message, variant } = await postForm({
            data: action.payload.data,
            url: updateUrl.href,
            onProgress: ({ progress, secondsRemaining }) => {
              if (getWasRedirected()) {
                store.dispatch(uploadProgress({ id, progress, secondsRemaining }));
              }
            },
          });
          if (wasRedirected) {
            store.dispatch(pushSnackbar({
              message,
              variant,
              link: selfURl,
            }));
          }
        } catch {
          if (wasRedirected) {
            store.dispatch(pushSnackbar({
              message: `${i18n._('Upload failed')}, ${i18n._('draft')} ${id} ${i18n._('saved')}`,
              variant: 'warning',
              link: selfURl,
            }));
          }
        } finally {
          if (!wasRedirected) {
            clearTimeout(toleranceTimeout);
            $.pjax({ url: selfURl, container: PJAX_MAIN_CONTAINER_SELECTOR });
          } else {
            reloadList();
          }
          store.dispatch(uploadEnd({ id }));
        }
      }
      return next(action);
    }

    default:
      return next(action);
  }
};

export default upload;
